import Container from "juis-components/Container.js";
import HTML from "./utils/HTML.js";
import BULMA from "./bulma_components/bulmaCssClasses.js";
import TextComponent from "./components/TextComponent.js";
import {extendComponent} from "juis-components/ComponentUtils.js";
import {createIcon} from "./bulma_components/Icon.js";

export default extendComponent(Container, function () {
    this.getNode().addWrapper(HTML.SECTION, [BULMA.SECTION]);

    this.icon = createIcon("exclamation-triangle", BULMA.TYPOGRAPHY.HAS_TEXT_DANGER);
    this.icon.isLarge = true;

    this.text = new TextComponent("Something went wrong", HTML.DIV, "title");
    this.setText = (text) => this.text.text = text;

}, [BULMA.HAS_TEXT_CENTERED]);
